import React from 'react'
import { getMessage } from 'lib/translator'
import { ANALYTICS_PLACEHOLDER } from './utils'
import { Input, VALIDATION_TYPES } from 'components/Form'
import Analytic from '../Analytic'

const ClickToAction = ({
  generateStateMappers,
  errorFields,
  dismissErrors,
}) => {
  return (
    <>
      <h3 className="two-col">{getMessage('app.popup.cta.button')}</h3>
      <Input
        required
        type="text"
        label={getMessage('app.popup.cta.text')}
        placeholder={getMessage('app.popup.cta.text.placeholder')}
        {...generateStateMappers({
          stateKeys: ['seeBtn', 'cta', 'text'],
          validationType: VALIDATION_TYPES.ONSUBMIT,
          loseEmphasisOnFill: true,
        })}
      />
      <Input
        required
        type="text"
        label={getMessage('app.popup.cta.deeplink')}
        placeholder={getMessage('app.popup.cta.deeplink.placeholder')}
        {...generateStateMappers({
          stateKeys: ['seeBtn', 'cta', 'deeplink'],
          validationType: VALIDATION_TYPES.ONSUBMIT,
          loseEmphasisOnFill: true,
        })}
      />
      <Analytic
        type="seeBtn"
        errorFields={errorFields}
        dismissErrors={dismissErrors}
        placeholder={ANALYTICS_PLACEHOLDER}
        generateStateMappers={generateStateMappers}
        stateKeys={['seeBtn', 'analytic']}
      />
    </>
  )
}

export default ClickToAction
